import { EventSourcePolyfill } from 'event-source-polyfill';
import { useRef } from 'react';

import LogoutForceModal from '@/components/modals/LogoutForce';
import { removeAuthToken } from '@/helpers/API';
import { ModalService as modal } from '@/libs/Modal';

const useAuthGuard = () => {
  const eventSource = useRef(null);

  const connectSSE = (token) => {
    if (eventSource.current) return;

    const url = `${process.env.REACT_APP_API_URL}/fo/auth/events`;
    eventSource.current = new EventSourcePolyfill(url, {
      headers: { Authorization: `Bearer ${token}` },
      heartbeatTimeout: 90 * 1000, // 90초
    });

    // 서버에서 중복 로그인 감지 시 강제 로그아웃
    eventSource.current.addEventListener('force-logout', ({ data }) => {
      disconnectSSE();
      removeAuthToken();
      modal.show(LogoutForceModal, { data: JSON.parse(data) });
    });

    eventSource.current.onerror = () => {
      disconnectSSE();
      setTimeout(() => connectSSE(), 5000);
    };
  };

  const disconnectSSE = () => {
    if (eventSource.current) {
      eventSource.current.close();
      eventSource.current = null;
    }
  };

  return { connectSSE, disconnectSSE };
};

export default useAuthGuard;
